/* Anew mobilmenu (2026-10)
   Åbner produktpanelet for en kollektion inde i menuen i stedet for at gå til kollektionssiden.
   Bruger bevidst <a role="button"> i stedet for <button>, fordi temaets MenuDrawer (global.js)
   lukker hele menuen ved klik på enhver <button> inde i header-drawer. */
if (!customElements.get('anew-mobile-nav')) {
  class AnewMobileNav extends HTMLElement {
    connectedCallback() {
      this.root = this.querySelector('[data-anew-root]');
      this.current = null;

      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-anew-open]');
        if (opener && this.contains(opener)) {
          const panel = this.querySelector('#' + CSS.escape(opener.getAttribute('aria-controls')));
          if (!panel) return; // ingen panel -> følg linket som normalt
          event.preventDefault();
          this.open(panel, opener);
          return;
        }
        const chip = event.target.closest('[data-anew-filter]');
        if (chip && this.contains(chip)) {
          event.preventDefault();
          this.applyFilter(chip);
          return;
        }
        const closer = event.target.closest('[data-anew-close]');
        if (closer && this.contains(closer)) {
          event.preventDefault();
          this.close();
        }
      });

      // Mellemrumstast på "Tilbage" (role=button)
      this.addEventListener('keydown', (event) => {
        if (event.key === ' ' && event.target.matches('[data-anew-close]')) {
          event.preventDefault();
          this.close();
        } else if (event.key === ' ' && event.target.matches('[data-anew-filter]')) {
          event.preventDefault();
          this.applyFilter(event.target);
        }
      });

      this.prepareFilters();

      // Nulstil til niveau 1 når hele menuen lukkes
      const details = this.closest('details');
      if (details) {
        new MutationObserver(() => {
          if (!details.hasAttribute('open')) this.close(true);
        }).observe(details, { attributes: true, attributeFilter: ['open'] });
      }
    }

    // Skjul filterknapper uden produkter - og hele rækken hvis kun "Alle" er tilbage
    prepareFilters() {
      this.querySelectorAll('[data-anew-filters]').forEach((row) => {
        const panel = row.closest('.anew-mnav__panel');
        const products = Array.from(panel.querySelectorAll('.anew-mnav__product'));
        let visible = 0;
        row.querySelectorAll('[data-anew-filter]').forEach((chip) => {
          const handle = chip.dataset.anewFilter;
          if (!handle) return;
          const hits = products.filter((p) => (p.dataset.collections || '').includes(' ' + handle + ' ')).length;
          if (hits === 0) chip.hidden = true;
          else visible += 1;
        });
        if (visible === 0) row.hidden = true;
      });
    }

    applyFilter(chip) {
      const row = chip.closest('[data-anew-filters]');
      const panel = chip.closest('.anew-mnav__panel');
      const handle = chip.dataset.anewFilter;
      row.querySelectorAll('[data-anew-filter]').forEach((c) => {
        const active = c === chip;
        c.classList.toggle('is-active', active);
        c.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      panel.querySelectorAll('.anew-mnav__product').forEach((p) => {
        const show = !handle || (p.dataset.collections || '').includes(' ' + handle + ' ');
        p.closest('li').hidden = !show;
      });
    }

    open(panel, opener) {
      if (this.current) this.close(true);
      panel.removeAttribute('inert');
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.add('is-open');
      const scroller = panel.querySelector('.anew-mnav__panel-scroll');
      if (scroller) scroller.scrollTop = 0;
      opener.setAttribute('aria-expanded', 'true');
      this.classList.add('is-panel-open');
      this.current = { panel, opener };
      // Flyt fokus ind i panelet før niveau 1 gøres inert, så fokus ikke tabes
      const back = panel.querySelector('[data-anew-close]');
      if (back) back.focus({ preventScroll: true });
      if (this.root) this.root.setAttribute('inert', '');
    }

    close(silent = false) {
      if (!this.current) return;
      const { panel, opener } = this.current;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      opener.setAttribute('aria-expanded', 'false');
      this.classList.remove('is-panel-open');
      if (this.root) this.root.removeAttribute('inert');
      this.current = null;
      if (!silent) opener.focus({ preventScroll: true });
      panel.setAttribute('inert', '');
    }
  }

  customElements.define('anew-mobile-nav', AnewMobileNav);
}
